import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["label", "hasError", "disabled", "readOnly", "hint"];
import React, { forwardRef } from 'react';
import Label from '../Label';
import Switch from '../Switch';
import Box from '../Box';
import SuperFieldHint from '../SuperFieldHint';

var getVariant = function getVariant(_ref) {
  var hasError = _ref.hasError,
      readOnly = _ref.readOnly,
      disabled = _ref.disabled;

  if (hasError) {
    return 'danger';
  }

  if (disabled || readOnly) {
    return 'disabled';
  }
};

var SwitchField = /*#__PURE__*/forwardRef(function (_ref2, ref) {
  var label = _ref2.label,
      hasError = _ref2.hasError,
      disabled = _ref2.disabled,
      readOnly = _ref2.readOnly,
      hint = _ref2.hint,
      rest = _objectWithoutProperties(_ref2, _excluded);

  return /*#__PURE__*/React.createElement(Box, {
    ref: ref,
    variant: getVariant({
      hasError: hasError,
      readOnly: readOnly,
      disabled: disabled
    }),
    pb: 2
  }, /*#__PURE__*/React.createElement(Label, {
    alignItems: "center"
  }, /*#__PURE__*/React.createElement(Switch, _extends({}, rest, {
    disabled: disabled
  })), label), hint ? /*#__PURE__*/React.createElement(SuperFieldHint, null, hint) : null);
});
SwitchField.displayName = 'SwitchField';
export default SwitchField;